/**
 * RESPONSIBILITY: the templates a section of the Visit page may be built from.
 *
 * THESE STRINGS ARE STORED. A saved section says which template it is by this text, so
 * renaming one silently blanks every section using it. Add freely; rename never.
 *
 * `Alternating` is what every band on this page was before there was a choice - a picture
 * and its words, the side swapping with position, a heading and one optional link. It is
 * the DEFAULT and what a band saved before this field existed means, so the page did not
 * change the day templates arrived and nothing had to be converted. The rest are the set
 * the ministries page offers, plus the three a first-time visitor's page needs: facts
 * (when and where), a call to action (the way in), and a location.
 */
export const VISIT_THEME = {
  Alternating: 'Image and text, alternating',
  Text: 'Text',
  Image: 'Image',
  ImageLeft: 'Image left, text right',
  ImageRight: 'Text left, image right',
  ImageTop: 'Image on top, text below',
  TextTop: 'Text on top, image below',
  Facts: 'Facts',
  Cta: 'Call to action',
  Location: 'Location',
  Faq: 'Questions and answers',
  Video: 'Video',
  Gallery: 'Gallery',
} as const;

export const VISIT_THEMES = Object.values(VISIT_THEME);

/** What a band with no template stored is. See the note above. */
export const DEFAULT_VISIT_THEME = VISIT_THEME.Alternating;
